// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { productAvailabilityStyles } from "@west/Overrides/Components/ProductAvailability";
import { css } from "styled-components";

productAvailabilityStyles.container = {
    css: css`
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 4px;
        flex-direction: column;
    `,
};

productAvailabilityStyles.availabilityByWarehouseLinkGridItem = {
    css: css`
        line-height: initial;
    `,
};

productAvailabilityStyles.realTimeText = {
    size: 12,
    lineHeight: "14px",
    weight: "bold",
};

productAvailabilityStyles.messageText = {
    size: 12,
    lineHeight: "14px",
    weight: "bold",
};

productAvailabilityStyles.inventoryMessage = {
    css: css`
        padding: initial;
        border-radius: initial;
        background-color: initial;

        display: flex;
        align-items: center;
        gap: 4px;
        color: ${({ color }: any) => getColor(color)};
        ${IconWrapper} {
            opacity: 0.66;
            margin-right: 0;
        }
    `,
};

productAvailabilityStyles.availabilityByWarehouseModal = {
    size: 400,
};

productAvailabilityStyles.errorText = {
    weight: "bold",
    size: 12,
};
